import { css } from 'styled-components'

export const defaultPadding = 0.5
export const directionalPadding = (value = defaultPadding) => css`
  div[dir=ltr][class=lang] & {
    padding-left: ${value}em;
  }
  div[dir=rtl][class=lang] & {
    padding-right: ${value}em;
  }  
`